import * as React from "react";
import { LocalizedComponentClass, withLocalization } from "bernie-l10n";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { TravelerReviewContent } from "typings/microserviceModels/hotels-flex-module";
import { useLocalization } from "@shared-ui/localization-context";

interface TravelerReviewsContentProps {
  hotelId: string;
  travelerReviewContent?: TravelerReviewContent;
}

export const TravelerReviewsComponent = (props: TravelerReviewsContentProps) => {
  if (!props.travelerReviewContent) {
    return null;
  }
  const { formatText } = useLocalization();
  const { titleKey, contentText } = props.travelerReviewContent;
  const title = titleKey && formatText(titleKey);

  return (
    <div className="all-t-padding-two uitk-type-paragraph-200">
      <UitkIcon name="sentiment_4" size={UitkIconSize.SMALL} className="all-r-padding-one" />
      {title}
      {contentText}
    </div>
  );
};

export const TravelerReviewsContent: LocalizedComponentClass<TravelerReviewsContentProps> = withLocalization(
  TravelerReviewsComponent
);
